<template>
  <div class="productInfo">
    <div class="box">
      <h3>专属客服</h3>
      <hr class="mt-4 mb-4">
      <div v-if="isLoading">
        <div class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="kefuBox" v-if="!isLoading && (dataInfo.moreInfo.privateService || dataInfo.dealerKefu)">
        {{dataInfo.moreInfo.privateService?dataInfo.moreInfo.privateService:dataInfo.dealerKefu}}
      </div>
      <div v-if="!isLoading && !dataInfo.moreInfo.privateService && !dataInfo.dealerKefu">
        暂未分配专属客服...
      </div>
    </div>
  </div>
</template>

<script>
import resultcommons from '../../util/resultcommons'; // 引入通用函数

export default {
  name: 'productInfo',
  props:['obj'],
  data () {
    return {
      dataInfo:{},
      isLoading:true
    }
  },
  methods:{
    // 获取基本信息
    apiCrmdatainfo() {
      this.isLoading = true;
      return resultcommons.apiCrmdatainfo(this,{}).then(app=>{
        if(app.state === 200){
          this.dataInfo = app.data;
          this.isLoading = false;
        }else{
          // 请求失败
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
        }
      });
    }
  },
  created() {
    this.apiCrmdatainfo();
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.productInfo {
  box-shadow: 0 0 1.5rem rgba(18, 38, 63, .1);
  color: #000000;
  background: #FFFFFF;
  width: 480px;
  height: 100%;
  border-radius: 10px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 50px;
  background: url("/static/images/staticsimg.jpg") no-repeat center center;
  background-size: cover;
  /*通用滚动条样式*/
  div.box{
    hr{
    }
  }
}
@media (max-width: 767px) {
  .productInfo {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/wechat.vue